import Image from "../Image/Image"
import { useAppContent } from "../../../shared/AppContent";
import { getMobileHeader } from "../../../shared/utility";
import { getPartnerName } from "../../../shared/PartnerUtility";
//import { appNavigateTo } from '../../../store/actions/navActions';
//import { useDispatch } from 'react-redux';
//import { useSelector } from "react-redux";
import { isMobile } from "../../../shared/photo.utility";

const MobileHeader = ({ goTo, getSection, classes, handlePopup }) => {
  //const dispatch = useDispatch();
  //const state = useSelector((state) => state.AppNav);
  //const currentpage = state?.goTo;
  const { cardTilePageContent } = useAppContent();
  let partnerRedirect = getPartnerName();

  return <><div className={classes.SMHead}>
    <span className={classes.SectionContent}>
      {getMobileHeader(goTo, getSection, cardTilePageContent)}
    </span>
  </div>
    {!(isMobile() && partnerRedirect) ? <div className={classes.CloseHelpButton}>
      <button onClick={() => handlePopup(true)} className={classes.CloseSm}>
        <Image filename={"Group411"} ext="png" alt="" />
      </button>
      {/*<button className={classes.HelpSm} onClick={() => { dispatch(appNavigateTo({ goTo: "helpcenter", previouspage: currentpage }, 'APP_NAVIGATE_TO')) }}>
        <Image filename={"help_outline_black_24dp"} ext="png" alt="" />
      </button>*/}
    </div> : null}</>
}
export default MobileHeader